<template>
  <LandingHero
    title="WELCOME TO THE"
    emphasized-title="STYLING SERIES"
    description="From print edits to date night dressing, this is your Rat & Boa guide to getting dressed."
    :images="heroImages"
  />
  <div class="blog-grid">
    <StyleSeriesTile
      v-for="entry in styleSeriesEntries"
      :key="entry.id"
      :entry="entry"
    />
  </div>
</template>

<script>
import LandingHero from "@/components/style-series/LandingHero.vue";
import StyleSeriesTile from "@/components/style-series/StyleSeriesTile.vue";
import StyleSeriesLandingContent from "@/content/StyleSeriesLanding.json";

export default {
  // Keep component name aligned with existing <blog-page> mount point
  name: "BlogPage",
  components: {
    LandingHero,
    StyleSeriesTile,
  },
  data() {
    return {
      styleSeriesEntries: StyleSeriesLandingContent.entries.map(
        (entry, index) => ({
          ...entry,
          id: entry.url || index,
          excerpt: entry.blurb,
          tags: entry.type ? [entry.type] : [],
          onlineStoreUrl: entry.url,
          image: {
            url:
              entry.images?.largeMedia ||
              entry.images?.mediumMedia ||
              entry.images?.smallMedia ||
              "",
            altText: entry.images?.altText || entry.title,
          },
        })
      ),
    };
  },
  computed: {
    heroImages() {
      return {
        smallMedia:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/390_Editorial_-_Section_2_2_1.jpg?v=1788954546",
        mediumMedia:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/390_Editorial_-_Section_2_2_1.jpg?v=1788954546",
        largeMedia:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/Hero_Image_3_1_1.jpg?v=1788954538",
        altText: "Style Series landing hero",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.blog-grid {
  display: grid;
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  box-sizing: border-box;
  grid-template-columns: 1fr;
  row-gap: 60px;
  padding: 60px 20px 80px;

  @include respond-above(md) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    column-gap: 40px;
    row-gap: 80px;
    padding: 80px 40px 120px;
  }

  @include respond-above(xl) {
    column-gap: 80px;
    row-gap: 80px;
    padding: 80px 80px 120px;
  }
}
</style>
